const $ = jQuery;
const $window = $(window);

const getResultsWithPager = () => {
  $('.custom-pager').empty();
  const results = $('.search-api-lunr-teaser');
  const step = 6;
  let resultsLeft = 0;
  let showingResults = 0;

  if (results.length > step) {
    results.each(function (i, obj) {
      if (i < step) {
        obj.classList.remove('hidden');
        showingResults += 1;
      } else {
        resultsLeft += 1;
      }
    });

    $('.sp-results').append(
      `<div class="custom-pager"><a class="btn btn-outline-dark load-more custom-search-btn" rel="next">Load More</a></div>`,
    );

    $('.custom-search-btn').on('click', function () {
      if (resultsLeft <= 10) {
        results.each(function (i, obj) {
          if (i >= step) {
            obj.classList.remove('hidden');
          }
        });
        $('.custom-pager').empty();
      } else {
        for (let i = 0; i < 10; i++) {
          results[showingResults].classList.remove('hidden');
          resultsLeft -= 1;
          showingResults += 1;
        }
      }
    });
  } else {
    results.each(function (i, obj) {
      if (i < step) {
        obj.classList.remove('hidden');
      }
    });
  }
};

const initSearch = () => {
  const els = once('search-page', '.search-page');
  els.forEach(() => {
    const targetNode = document.getElementById('os-search-page');

    const config = {
      childList: true,
      subtree: true,
    };

    const observer = new MutationObserver(function () {
      if ($('.search-api-lunr-teaser').length > 0) {
        getResultsWithPager();
        observer.disconnect();
      }
    });

    $('.os-search').on('click', () => observer.observe(targetNode, config));

    observer.observe(targetNode, config);
  });
};

$window.on('load', () => initSearch());
